<div class="relative flex items-center">
  @if (currency) {
    <ng-container *ngTemplateOutlet="selectedCurrencySymbol" />
  }

  <input
    type="text"
    inputmode="decimal"
    [ngClass]="[
      currency ? '!pl-8' : '',
      disabled || readonly ? 'pointer-events-none !text-slate-400' : '',
    ]"
    [ngModel]="value"
    (ngModelChange)="onInputChange($event)"
    (input)="onInputChange($event)"
    [placeholder]="placeholder"
    [attr.pattern]="pattern"
    (blur)="handleBlur()"
    (focus)="$event.target.select()"
    [disabled]="disabled"
    [readonly]="readonly"
  />
</div>

<ng-template #selectedCurrencySymbol>
  <div
    class="absolute left-1 top-1/2 -translate-y-1/2 font-medium text-french-blue-600"
  >
    <!-- currency icon -->
    <div
      [ngClass]="disabled || readonly ? 'pointer text-slate-400' : ''"
      class="grid h-6 w-6 place-items-center"
    >
      {{ isPercentage ? "%" : currencyService.getCurrencySymbol(currency) }}
    </div>
  </div>
</ng-template>
